export var ObjectTypesValues;
(function (ObjectTypesValues) {
    ObjectTypesValues[ObjectTypesValues["Manufacture"] = 1] = "Manufacture";
    ObjectTypesValues[ObjectTypesValues["TechObject"] = 2] = "TechObject";
    ObjectTypesValues[ObjectTypesValues["TechLine"] = 3] = "TechLine";
    ObjectTypesValues[ObjectTypesValues["Plant"] = 4] = "Plant";
    ObjectTypesValues[ObjectTypesValues["Contour"] = 5] = "Contour";
})(ObjectTypesValues || (ObjectTypesValues = {}));
export var ObjectTypesNames;
(function (ObjectTypesNames) {
    ObjectTypesNames["Manufacture"] = "\u0417\u0430\u0432\u043E\u0434";
    ObjectTypesNames["TechObject"] = "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E";
    ObjectTypesNames["TechLine"] = "\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043B\u0438\u043D\u0438\u044F";
    ObjectTypesNames["Plant"] = "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430";
    ObjectTypesNames["Contour"] = "\u041A\u043E\u043D\u0442\u0443\u0440";
})(ObjectTypesNames || (ObjectTypesNames = {}));
export var OBJECT_TYPES_NAMES = [
    ObjectTypesNames.Manufacture,
    ObjectTypesNames.TechObject,
    ObjectTypesNames.TechLine,
    ObjectTypesNames.Plant,
    ObjectTypesNames.Contour,
];
